import { v4 as uuidv4 } from 'uuid'

import type { OfferApi } from '@fourthwall/services/dist/OffersApiClient'

import type { OfferImageTag } from '../../../../../SingleProduct.types'
import type { OfferImagesFieldValue, OfferImagesFilter } from '../../../types'

export const mapUploadedFilesToVariantImages = ({
  results,
  filters,
}: {
  results: {
    result: OfferApi.UploadImageResponse
    uploadToAllVariants: boolean
  }[]
  filters: OfferImagesFilter[]
}) => {
  const items: OfferImagesFieldValue = []

  results.forEach(({ result, uploadToAllVariants }) => {
    if (uploadToAllVariants) {
      const combinations = getImageTagsCombinations(filters)
      combinations.forEach((combination) => {
        items.push({
          id: uuidv4(),
          url: result.files.length ? result.files[0].uri : '',
          tags: combination,
          position: 0,
        })
      })
    } else {
      items.push({
        id: uuidv4(),
        url: result.files.length ? result.files[0].uri : '',
        tags: filters.map<OfferImageTag>((filter) => ({ type: filter.tag, name: filter.value })),
        position: 0,
      })
    }
  })

  return items
}

function getImageTagsCombinations(filters: OfferImagesFilter[]): OfferImageTag[][] {
  return filters.reduce<OfferImageTag[][]>((acc, filter) => {
    if (acc.length === 0) {
      return filter.options.map((option) => [
        {
          type: filter.tag,
          name: option.value,
        },
      ])
    }

    return acc.flatMap((combination) =>
      filter.options.map((option) => [
        ...combination,
        {
          type: filter.tag,
          name: option.value,
        },
      ]),
    )
  }, [])
}
